import { ProductModelService } from "../models";
import { getMeterSerial, maskIdMeter } from "../utils";

export const getSerialAndAttributeName = (deviceId: string) => {
  const product = new ProductModelService(deviceId);

  return {
    serial: product.type?.name=== 'meter' ? getMeterSerial(product.id.toUpperCase()) : product.id.toUpperCase(),
    attributeName: product.type?.name === 'meter' ? maskIdMeter(getMeterSerial(product.id.toUpperCase())) : product.id.toUpperCase(),
  };
}